import React from 'react';
import { TrendingUp } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import Modal from '../ui/Modal';

const DiscountConfirmationModal = () => {
  const app = useAppContext();

  return (
    <Modal
      isOpen={app.showDiscountConfirmation}
      onClose={() => app.setShowDiscountConfirmation(false)}
      size="sm"
    >
      <div className="modal__header">
        <div className="modal__icon-wrapper modal__icon-wrapper--success">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" className="checkmark-path" />
          </svg>
        </div>
        <h2 className="modal__title">Discount Applied!</h2>
        <p className="modal__subtitle">
          Your next bill will be <strong className="modal__highlight">$49.50</strong> instead of $99.
        </p>
      </div>
      <div className="modal__body">
        <button
          className="btn btn-primary btn-full"
          onClick={() => app.setShowDiscountConfirmation(false)}
        >
          <TrendingUp size={18} />
          Continue Trading
        </button>
      </div>
    </Modal>
  );
};

export default DiscountConfirmationModal;
